import { useAppSelector } from '#app/hooks/useAppStore';

function selectIsLoaded(s) {
  return (
    !s.interfaceComponents.clientLoading &&
    !s.interfaceComponents.currencyLoading &&
    !s.account.accountLoading &&
    !s.scenario.formLoading &&
    !s.interfaceComponents.incomeTypesLoading &&
    !s.interfaceComponents.spendTypesLoading &&
    !s.interfaceComponents.tagsLoading &&
    !s.interfaceComponents.subcategoriesLoading
  );
}

export function usePagesRouterState() {
  const auth = useAppSelector((s) => s.auth.auth);
  const authData = useAppSelector((s) => s.auth.data);
  const client = useAppSelector((s) => s.interfaceComponents.client);
  const demo = useAppSelector((s) => s.scenario.demo);
  const isLoaded = useAppSelector(selectIsLoaded);
  const maintenanceMode = useAppSelector((s) => s.maintenance.maintenanceMode);

  return {
    auth,
    authData,
    client,
    demo,
    isLoaded,
    maintenanceMode,
  };
}
